var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGiphy = function SvgGiphy(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "4 2 16.32 20"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.331 4.286H17.99v15.428H6.33z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4 3.714h2.331v16.572H4z",
    fill: "#04ff8e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.989 8.286h2.331v12h-2.331z",
    fill: "#8e2eff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 19.714h16.32V22H4z",
    fill: "#00c5ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 2h9.326v2.286H4z",
    fill: "#fff152"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.989 6.571V4.286h-2.332V2h-2.331v6.857h6.994V6.571",
    fill: "#ff5b5b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.989 11.143V8.857h2.331",
    fill: "#551c99"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M13.326 2v2.286h-2.332",
    fill: "#999131"
  }))));
};
export default SvgGiphy;